import { db } from "@/main";

import { DB } from "@/common/store";
import { XRAY } from "@/store/offsiteService";

export function AddXraySubmission(scheduleId, userCode, photo) {
  return new Promise((resolve, reject) => {
    db.collection(DB.OFFSITE_SUBMISSIONS)
      .add({
        photo: photo,
        scheduleId: scheduleId,
        timestamp: new Date(),
        type: XRAY,
        userCode: userCode
      })
      .then(() => resolve())
      .catch(err => reject(err));
  });
}

export function GetXraySubmission(scheduleId, userCode) {
  return new Promise((resolve, reject) => {
    db.collection(DB.OFFSITE_SUBMISSIONS)
      .where("scheduleId", "==", scheduleId)
      .where("userCode", "==", userCode)
      .where("type", "==", XRAY)
      .get()
      .then(snapshot => {
        let lastSubmission = null;
        let xray = "";

        snapshot.forEach(doc => {
          const data = doc.data();
          if (!lastSubmission || lastSubmission < data.timestamp) {
            lastSubmission = data.timestamp;
            xray = data.photo;
          }
        });

        resolve({ xray: xray });
      })
      .catch(err => reject(err));
  });
}
